import apiClient from '@u/apiClient'

export default {
  fetchMailboxMessages({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      apiClient
        .get(`dossier/${payload.dossier_id}/mailbox`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
